import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'barred'
})
export class BarredPipe implements PipeTransform {
  transform(value: string): string {
    return '/';
  }
}
